import { Card, Paragraph } from '@zillow/constellation-10';
import type { TooltipProps } from 'recharts';

const ChartTooltip: TooltipProps<number, string>['content'] = (props) => {
  const { active, payload, formatter } = props;
  if (active && payload && payload.length) {
    return (
      <Card tone="neutral">
        {payload
          .slice(0)
          .reverse()
          .map((p) => (
            <Paragraph textStyle="body-xs" key={p.name}>
              {formatter && formatter(p)}
            </Paragraph>
          ))}
      </Card>
    );
  }
  return null;
};

export default ChartTooltip;
